export default __webpack_public_path__ + "static/media/zhuanli3.c5f9d232.jpg";